(function () {
  var state = { has_transfers: false, has_blanks: false, cart_value: 0, item_count: 0 };

  var popupEnvironment = (window.Shopify && window.Shopify.theme &&
    window.Shopify.theme.role === "main") ? "production" : "staging";
  var shownTimestamp = null;
  var clickedCardData = null;
  var dismissedEventFired = false;
  var initialized = false;
  var popupOpen = false;
  var activeTab = 'popular';
  var tabFetches = {};

  function fireEvent(name, params) {
    if (typeof gtag !== "undefined") {
      params.device_type = window.innerWidth <= 767 ? "mobile" : "desktop";
      gtag("event", name, params);
    }
  }

  function elapsedMs() {
    return shownTimestamp ? Date.now() - shownTimestamp : 0;
  }

  function activateScripts(container) {
    var scripts = container.querySelectorAll('script');
    for (var i = 0; i < scripts.length; i++) {
      var old = scripts[i];
      var el = document.createElement('script');
      if (old.src) {
        el.src = old.src;
      } else {
        el.textContent = old.textContent;
      }
      for (var a = 0; a < old.attributes.length; a++) {
        var attr = old.attributes[a];
        if (attr.name !== 'src') el.setAttribute(attr.name, attr.value);
      }
      old.parentNode.replaceChild(el, old);
    }
  }

  function fetchTabContent(tab) {
    if (tabFetches[tab]) return tabFetches[tab];

    var dialog = getDialog();
    if (!dialog) return Promise.resolve();
    var panel = dialog.querySelector('.blanks-popup__tab-panel[data-tab="' + tab + '"]');
    if (!panel || panel.getAttribute('data-loaded') === 'true') return Promise.resolve();

    var url = panel.getAttribute('data-fetch-url');
    if (!url) return Promise.resolve();

    tabFetches[tab] = fetch(url, { cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        panel.innerHTML = html;
        panel.setAttribute('data-loaded', 'true');
        activateScripts(panel);
        if (typeof window.refreshGRTUpsellBlocks === 'function') {
          requestAnimationFrame(function () {
            window.refreshGRTUpsellBlocks();
            setTimeout(window.refreshGRTUpsellBlocks, 300);
          });
        }
      })
      .catch(function () {
        delete tabFetches[tab];
      });

    return tabFetches[tab];
  }

  function prefetchTabs() {
    var TABS = ['tees', 'sweatshirts', 'hats', 'bags'];
    var idx = 0;
    var ric = window.requestIdleCallback || function (cb) { setTimeout(cb, 100); };

    function next() {
      if (!popupOpen) return;
      if (idx >= TABS.length) return;
      var tab = TABS[idx++];
      var dialog = getDialog();
      if (!dialog) return;
      var panel = dialog.querySelector('.blanks-popup__tab-panel[data-tab="' + tab + '"]');
      if (!panel || panel.getAttribute('data-loaded') === 'true') {
        ric(next);
        return;
      }
      fetchTabContent(tab).then(function () { ric(next); }).catch(function () { ric(next); });
    }

    ric(next);
  }

  function switchTab(newTab) {
    if (newTab === activeTab) return;
    var dialog = getDialog();
    if (!dialog) return;

    var fromTab = activeTab;
    activeTab = newTab;

    var panels = dialog.querySelectorAll('.blanks-popup__tab-panel');
    for (var i = 0; i < panels.length; i++) {
      panels[i].style.display = panels[i].getAttribute('data-tab') === newTab ? '' : 'none';
    }

    var tabs = dialog.querySelectorAll('.blanks-popup__tab');
    for (var j = 0; j < tabs.length; j++) {
      var isActive = tabs[j].getAttribute('data-tab') === newTab;
      tabs[j].classList.toggle('blanks-popup__tab--active', isActive);
      tabs[j].setAttribute('aria-selected', String(isActive));
    }

    var targetPanel = dialog.querySelector('.blanks-popup__tab-panel[data-tab="' + newTab + '"]');
    if (targetPanel && targetPanel.getAttribute('data-loaded') === 'false') {
      fetchTabContent(newTab);
    } else if (typeof window.refreshGRTUpsellBlocks === 'function') {
      requestAnimationFrame(window.refreshGRTUpsellBlocks);
    }

    fireEvent('popup_tab_switched', {
      from_tab: fromTab,
      to_tab: newTab,
      time_on_popup_ms: elapsedMs(),
      popup_version: 'v1',
      popup_environment: popupEnvironment
    });
  }

  function resetTabs() {
    activeTab = 'popular';
    var dialog = getDialog();
    if (!dialog) return;
    var panels = dialog.querySelectorAll('.blanks-popup__tab-panel');
    for (var i = 0; i < panels.length; i++) {
      panels[i].style.display = panels[i].getAttribute('data-tab') === 'popular' ? '' : 'none';
    }
    var tabs = dialog.querySelectorAll('.blanks-popup__tab');
    for (var j = 0; j < tabs.length; j++) {
      var isPopular = tabs[j].getAttribute('data-tab') === 'popular';
      tabs[j].classList.toggle('blanks-popup__tab--active', isPopular);
      tabs[j].setAttribute('aria-selected', String(isPopular));
    }
  }

  function readStateFromDOM(doc) {
    var el = (doc || document).getElementById("cart-blanks-state");
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function initState() {
    var parsed = readStateFromDOM();
    if (parsed) state = parsed;
  }

  function refreshState() {
    var dialog = getDialog();
    var sectionKey = dialog && dialog.dataset.sectionId;
    if (!sectionKey) return;
    fetch("/cart?sections=" + sectionKey, { cache: "no-store" })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[sectionKey];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, "text/html");
        var parsed = readStateFromDOM(doc);
        if (parsed) state = parsed;
      })
      .catch(function () {});
  }

  function getDialog() {
    return document.getElementById("blanks-upsell-popup");
  }

  function openPopup() {
    var dialog = getDialog();
    if (!dialog) return;

    dialog.showModal();
    popupOpen = true;
    document.body.classList.add("blanks-popup-open");
    setCookie("blank_upsell", "1", 1);
    resetTabs();

    shownTimestamp = Date.now();
    dismissedEventFired = false;
    fireEvent("popup_shown", {
      cart_value: state.cart_value || 0,
      cart_item_count: state.item_count || 0,
      popup_version: "v1",
      popup_environment: popupEnvironment
    });

    if (typeof window.refreshGRTUpsellBlocks === "function") {
      requestAnimationFrame(window.refreshGRTUpsellBlocks);
      setTimeout(window.refreshGRTUpsellBlocks, 300);
    }

    prefetchTabs();
  }

  function shouldFire() {
    return (
      state.has_transfers === true &&
      state.has_blanks === false &&
      getCook("blank_upsell") === ""
    );
  }

  function captureCardData(cardEl) {
    if (!cardEl) return;
    var handle = (cardEl.getAttribute("data-handle") || "").replace(/^\/products\//, "");
    var vid = cardEl.getAttribute("data-vid") || "";
    var title = "";
    var titleEl = cardEl.querySelector(".grt-product-card__title");
    if (titleEl) title = (titleEl.textContent || "").trim();

    var price = 0;
    var jsonEl = cardEl.closest("[data-upsell-item]");
    if (jsonEl) {
      var scriptEl = jsonEl.querySelector("[data-card-color-json]");
      if (scriptEl) {
        try {
          var colors = JSON.parse(scriptEl.textContent);
          for (var i = 0; i < colors.length; i++) {
            if (String(colors[i].vid) === String(vid)) {
              price = (colors[i].price || 0) / 100;
              break;
            }
          }
          if (!price && colors.length) price = (colors[0].price || 0) / 100;
        } catch (e) {}
      }
    }

    clickedCardData = { handle: handle, variant_id: vid, title: title, price: price };
  }

  function init() {
    if (initialized) return;
    initState();

    var dialog = getDialog();
    if (!dialog) return;

    $(document).on("click", '[href="/checkout"]:not(.skipchk)', function (e) {
      if (!shouldFire()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      openPopup();
    });

    /* Every dismiss CLOSES the dialog before pointing at /checkout (Owen
       9-18 mobile report). The old behavior left it open so the exit never
       flashed the cart page — but on iOS the /checkout navigation can be
       taken over by the Shop app (universal link): the tab never unloads,
       no pageshow ever fires, and the customer comes back from the app to
       the cart page with the popup still sitting open. Closing first is the
       only exit that works there; the pageshow guard below stays as the
       safety net for the browser-checkout + Back path. */
    function closeThenCheckout() {
      var d = getDialog();
      if (d && d.hasAttribute("open")) d.close();
      popupOpen = false;
      document.body.classList.remove("blanks-popup-open");
      window.location.href = "/checkout";
    }

    $(document).on("click", ".blanks-popup__close", function () {
      if (!dismissedEventFired) {
        dismissedEventFired = true;
        fireEvent("popup_dismissed", {
          dismiss_method: "close_button",
          time_on_popup_ms: elapsedMs(),
          popup_version: "v1",
          popup_environment: popupEnvironment
        });
      }
      closeThenCheckout();
    });

    dialog.addEventListener("click", function (e) {
      if (e.target === dialog) {
        if (!dismissedEventFired) {
          dismissedEventFired = true;
          fireEvent("popup_dismissed", {
            dismiss_method: "backdrop_click",
            time_on_popup_ms: elapsedMs(),
            popup_version: "v1",
            popup_environment: popupEnvironment
          });
        }
        closeThenCheckout();
      }
    });

    dialog.addEventListener("cancel", function (e) {
      // Suppress native ESC close so the keydown handler owns the exit and
      // fires the dismissed event before closeThenCheckout() runs.
      e.preventDefault();
    });

    dialog.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && dialog.hasAttribute("open")) {
        // ESC while a quick-buy modal is open closes only that modal — leave the popup.
        if (dialog.querySelector(".grt-product-modal[open]")) return;
        if (!dismissedEventFired) {
          dismissedEventFired = true;
          fireEvent("popup_dismissed", {
            dismiss_method: "esc_key",
            time_on_popup_ms: elapsedMs(),
            popup_version: "v1",
            popup_environment: popupEnvironment
          });
        }
        closeThenCheckout();
      }
    });

    var skipLink = dialog.querySelector(".skipchk");
    if (skipLink) {
      skipLink.addEventListener("click", function () {
        /* Close BEFORE the anchor's native navigation for the same iOS
           Shop-app-hijack reason as closeThenCheckout — the tab may never
           unload, so the anchor path must not leave the dialog open either.
           The navigation itself stays native (href="/checkout"). */
        var d = getDialog();
        if (d && d.hasAttribute("open")) d.close();
        popupOpen = false;
        document.body.classList.remove("blanks-popup-open");
        if (dismissedEventFired) return;
        dismissedEventFired = true;
        fireEvent("popup_dismissed", {
          dismiss_method: "continue_to_checkout_link",
          time_on_popup_ms: elapsedMs(),
          popup_version: "v1",
          popup_environment: popupEnvironment
        });
      }, { once: true });
    }

    $(dialog).on("click", ".grt-qv-btn", function () {
      captureCardData(this);
    });

    $(dialog).on("click", "[data-close-modal]", function () {
      clickedCardData = null;
    });

    $(document).on("click", ".blanks-popup__tab", function () {
      var tab = this.getAttribute("data-tab");
      if (tab) switchTab(tab);
    });

    document.addEventListener("grt-upsell:added", function (e) {
      if (!e.detail || e.detail.source !== "grt-upsell") return;
      if (!shownTimestamp) return;

      var params = {
        product_handle: "",
        product_id: "",
        variant_id: "",
        product_price: 0,
        source_tab: activeTab,
        time_on_popup_ms: elapsedMs(),
        popup_version: "v1",
        popup_environment: popupEnvironment
      };

      if (clickedCardData) {
        params.product_handle = clickedCardData.handle;
        params.variant_id = clickedCardData.variant_id;
        params.product_price = clickedCardData.price;
        params.product_id = clickedCardData.handle;
      }

      fireEvent("popup_added_to_cart", params);
      clickedCardData = null;
    });

    document.addEventListener("cart-updated", refreshState);
    var cartForm = document.querySelector("cart-form");
    if (cartForm) {
      cartForm.addEventListener("cart-updated", refreshState);
    }

    /* One show only (Owen 9-18 video). Every dismiss path above deliberately
       navigates to /checkout with the dialog still OPEN (closing first
       flashes the cart page behind it — see the cancel-handler comment). The
       cost: the browser's back/forward cache snapshots the page WITH the open
       dialog, so Back from checkout resurrected the popup — a second "show"
       the blank_upsell cookie cannot prevent, because nothing re-fired it.
       pageshow fires on every bfcache restore; close the leftover dialog
       there. Not gated on e.persisted: a fresh load re-renders the dialog
       closed anyway, so the close is a no-op everywhere else. Keep this AND
       the navigate-while-open behavior — the no-flash exit depends on it. */
    window.addEventListener("pageshow", function () {
      var d = getDialog();
      if (d && d.hasAttribute("open")) {
        d.close();
        popupOpen = false;
        document.body.classList.remove("blanks-popup-open");
      }
    });

    initialized = true;
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
